import type { IconNode } from '../types';

/**
 * @name mango
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgNiAzLTMiIC8+CiAgPHBhdGggZD0iTTcgMjJhNCA0IDAgMDEtMi42Mi03LjAyM0EyIDIgMCAwMDUgMTMuMzgzVjEwYTggOCAwIDExMTYgMEExMiAxMiAwIDAxOSAyMnoiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mango
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Mango: IconNode = [
  ['path', { d: 'm17 6 3-3' }],
  ['path', { d: 'M7 22a4 4 0 01-2.62-7.023A2 2 0 005 13.383V10a8 8 0 1116 0A12 12 0 019 22z' }],
];

export default Mango;
